/** 表が空のとき。一文 + 次の行動(主ボタン 1 つ + 補助 1 つまで)。 */
import type { ReactNode } from "react";

export function EmptyState({
  text,
  action,
  secondaryAction,
}: {
  text: ReactNode;
  action?: ReactNode;
  /** 「条件を外す」など、主ボタンの横の補助 */
  secondaryAction?: ReactNode;
}) {
  return (
    <div className="ui-empty">
      <div>{text}</div>
      {(action || secondaryAction) && (
        <div className="ui-empty-actions">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
